<template>
  <div class="whyDesktron-div">
    <h2 class="common-title">为什么Desktron可以替换Citrix</h2>
    <div class="whyDesktron-container">
      <ul class="whyDesktron">
        <ul v-for="item in compareData" :key="item.key">
          <li class="whyDesktron-header">
            <div class="whyDesktron-item1 whyDesktron-border-top">
              {{ item.name }}
            </div>
            <div
              :class="[
                'whyDesktron-item3',
                item.key !== 1 && 'whyDesktron-border-top1',
              ]"
            >
              <img
                class="whyDesktron-desktron"
                src="@/assets/desktron/replaceCitrix/Desktron.png"
                v-if="item.key === 1"
              />
            </div>
            <div class="whyDesktron-item4 whyDesktron-border-top">
              <img
                class="whyDesktron-citrix"
                src="@/assets/desktron/replaceCitrix/citrix.png"
                v-if="item.key === 1"
              />
            </div>
          </li>
          <ul class="whyDesktron-all">
            <li
              class="whyDesktron-compare"
              v-for="(obj, index) in item.data"
              :key="index"
            >
              <div
                :class="[
                  'whyDesktron-item1',
                  index === 0 && 'whyDesktron-border-top',
                ]"
              >
                {{ obj.name }}
              </div>
              <div
                :class="[
                  'whyDesktron-item3',
                  index === 0 && 'whyDesktron-border-top1',
                ]"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19.7348 6.65376C20.1094 7.05958 20.0841 7.69224 19.6783 8.06684L9.56719 17.4002C9.36585 17.586 9.09707 17.6811 8.82364 17.6632C8.55022 17.6454 8.29611 17.5161 8.12069 17.3056L4.2318 12.6389C3.87824 12.2146 3.93556 11.584 4.35984 11.2305C4.78412 10.8769 5.41468 10.9342 5.76825 11.3585L8.98365 15.217L18.3217 6.59723C18.7276 6.22263 19.3602 6.24794 19.7348 6.65376Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div
                :class="[
                  'whyDesktron-item4',
                  index === 0 && 'whyDesktron-border-top',
                ]"
              >
                <svg
                  v-if="obj.citrix"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19.7348 6.65376C20.1094 7.05958 20.0841 7.69224 19.6783 8.06684L9.56719 17.4002C9.36585 17.586 9.09707 17.6811 8.82364 17.6632C8.55022 17.6454 8.29611 17.5161 8.12069 17.3056L4.2318 12.6389C3.87824 12.2146 3.93556 11.584 4.35984 11.2305C4.78412 10.8769 5.41468 10.9342 5.76825 11.3585L8.98365 15.217L18.3217 6.59723C18.7276 6.22263 19.3602 6.24794 19.7348 6.65376Z"
                    fill="#383E42"
                  />
                </svg>

                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.7071 5.03914C19.0976 5.42966 19.0976 6.06283 18.7071 6.45335L6.45423 18.7062C6.06371 19.0967 5.43055 19.0967 5.04002 18.7062C4.6495 18.3157 4.6495 17.6825 5.04002 17.292L17.2929 5.03914C17.6834 4.64861 18.3166 4.64861 18.7071 5.03914Z"
                    fill="#ED4751"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.03999 6.45423C4.64947 6.06371 4.64947 5.43054 5.03999 5.04002C5.43052 4.6495 6.06368 4.6495 6.45421 5.04002L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071Z"
                    fill="#ED4751"
                  />
                </svg>
              </div>
            </li>
          </ul>
        </ul>
      </ul>

      <!--
      <ul class="whyDesktron">
        <li class="whyDesktron-header">
          <div class="whyDesktron-item1 whyDesktron-border-top">维度</div>
          <div class="whyDesktron-item2 whyDesktron-border-top">特点</div>
          <div class="whyDesktron-item3">
            <img
              class="whyDesktron-desktron"
              src="@/assets/desktron/replaceCitrix/Desktron.png"
            />
          </div>
          <div class="whyDesktron-item4 whyDesktron-border-top">
            <img
              class="whyDesktron-citrix"
              src="@/assets/desktron/replaceCitrix/citrix.png"
            />
          </div>
        </li>

        <li
          class="whyDesktron-list"
          v-for="item in compareData"
          :key="item.key"
        >
          <div class="whyDesktron-item1 whyDesktron-border-top">
            {{ item.name }}
          </div>
        </li>
      </ul> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      compareData: Object.freeze([
        {
          key: 1,
          name: "性能体验",
          data: [
            {
              name: "支持4K分辨率",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持144FPS",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持444真彩模式",
              desktron: true,
              citrix: true,
            },
            {
              name: "外网访问",
              desktron: true,
              citrix: true,
            },
          ],
        },
        {
          key: 2,
          name: "信创兼容",
          data: [
            {
              name: "全面适配国产操作系统",
              desktron: true,
              citrix: false,
            },
            {
              name: "全面兼容国产CPU",
              desktron: true,
              citrix: false,
            },
            {
              name: "提供Windows应用终端过渡能力",
              desktron: true,
              citrix: false,
            },
          ],
        },
        {
          key: 3,
          name: "终端管理",
          data: [
            {
              name: "多终端全面兼容",
              desktron: true,
              citrix: false,
            },
            {
              name: "支持高性能服务器",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持物理PC部署",
              desktron: true,
              citrix: true,
            },
          ],
        },
        {
          key: 4,
          name: "数据安全",
          data: [
            {
              name: "支持零信任空间",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持水印",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持外设控制",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持日志录屏",
              desktron: true,
              citrix: true,
            },
          ],
        },
        {
          key: 5,
          name: "交付能力",
          data: [
            {
              name: "license管理",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持混合部署",
              desktron: true,
              citrix: true,
            },
            {
              name: "支持原厂服务",
              desktron: true,
              citrix: false,
            },
          ],
        },
      ]),
    };
  },
};
</script>
<style lang="less" scoped>
.whyDesktron-div {
  background: #fff;
}
.common-title {
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 40px 0 30px;
  line-height: 34px;
  color: #1d2129;
}
.whyDesktron-container {
  box-sizing: border-box;
  padding: 6px 20px 0;
  background: url("~@/assets/desktron/replaceCitrix/bg.png") no-repeat;
  background-position: 164px 0;
  background-size: 109px 960px;
  width: 100%;
}
.whyDesktron {
  border: 1px solid #dee0e3;
  border-top: none;
  color: #232729;
}

.whyDesktron-border-top {
  border-top: 1px solid #dee0e3;
}
.whyDesktron-border-top1 {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #0b5f9c;
    opacity: 0.2;
  }
}

.whyDesktron-header {
  height: 48px;
  display: flex;
  font-size: 16px;
  font-weight: 500;

  .whyDesktron-item1 {
    font-weight: 500;
  }
}

.whyDesktron-desktron {
  width: 92px;
  height: 24px;
  margin-bottom: 3px;
}

.whyDesktron-citrix {
  width: 67px;
  height: 24px;
}
.whyDesktron-all {
  flex: 1;
}
.whyDesktron-item1 {
  box-sizing: border-box;
  width: 143px;
  // border-right: 1px solid #dee0e3;
  display: flex;
  align-items: center;
  padding: 8px 12px 8px 12px;
  flex-shrink: 0;
}

.whyDesktron-item2 {
  box-sizing: border-box;
  width: 109px;
  padding-left: 30px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
}

.whyDesktron-item3 {
  width: 109px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
}

.whyDesktron-item4 {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: rgb(247, 248, 250);
}

.whyDesktron-list {
  // border-top: 1px solid #dee0e3;
  display: flex;
  box-sizing: border-box;
}

.whyDesktron-compare {
  display: flex;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  min-height: 40px;
}
</style>
